module.exports = __webpack_public_path__ + "img/oue-5.00d44cae.png";